import { createContext } from "react";

export const DateFormatContext = createContext<string>("yyyy-MM-dd");

export const DatetimeShortFormatContext =
  createContext<string>("yyyy-MM-dd HH:mm");

export const DatetimeFullFormatContext = createContext<string>(
  "yyyy-MM-dd HH:mm:ss zzz",
);

export const DatetimeISO8601FormatContext = createContext<string>(
  "yyyy-MM-dd'T'HH:mm:ssXXX",
);
